const OVERRIDE_LINK_PANEL_SECTIONS = 'override-link-panel-sections';

export { OVERRIDE_LINK_PANEL_SECTIONS };
